class PageDisruptor {
  constructor() {
    this.domElements = {};
    this.COOKIE_NAME = 'pagedisruptor';
    if (!this.initDomElements()) {
      return false;
    }

    if (!this.getCookie()) {
      this.showModal();
    }
  }

  initDomElements() {
    this.domElements.modal = $('.page-disruptor');
    if (this.domElements.modal.length < -1) {
      return false;
    }

    this.domElements.modalCloseBtn = $('.page-disruptor__close-btn');

    return true;
  }

  showModal() {
    console.log('showModal');
    this.domElements.modal.show();
    this.domElements.modalCloseBtn.focus();
    this.domElements.modalCloseBtn.one('click', () => {
      this.closeModal();
    });
  }

  closeModal() {
    this.domElements.modal.hide();
    this.setCookie();
  }

  initBlurListener() {
    this.domElements.modal.on('focusout', event => {
      if (!this.domElements.modal.has(event.relatedTarget).length) {
        this.closeModal();
      }
    });
  }

  setCookie() {
    document.cookie = this.COOKIE_NAME + '=' + this.COOKIE_NAME + ';path=/';
  }

  getCookie() {
    let name = this.COOKIE_NAME + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
}

export default PageDisruptor;
